import AnalyticsTemplate from "../../../templates/admin/analytics";

const AnalyticsScreen = () => {
  return <AnalyticsTemplate />;
};

export default AnalyticsScreen;
